/* eslint-disable import/prefer-default-export */
import { Record } from 'immutable';
import { Agent, Agreement, DateObject, ReduxAgreement } from 'services/resources';

const agentDefaultValues: Agent = {
  id: null,
  firstName: '',
  lastName: '',
  email: '',
};

export const makeAgent = Record(agentDefaultValues);

const agreementDefaultValues: Agreement = {
  additionalDriverAddress1: null,
  additionalDriverAddress2: null,
  additionalDriverCity: null,
  additionalDriverCountry: null,
  additionalDriverDateOfBirth: null,
  additionalDriverEmail: null,
  additionalDriverFirstName: null,
  additionalDriverLastName: null,
  additionalDriverLicenseExpires: null,
  additionalDriverLicenseNumber: null,
  additionalDriverLicenseState: null,
  additionalDriverPhone: null,
  additionalDriverPostalCode: null,
  additionalDriverState: null,
  advisorFirstName: null,
  advisorId: null,
  advisorLastName: null,
  agentIn: makeAgent({}),
  agentOut: makeAgent({}),
  balanceDue: null,
  balancePaid: null,
  batteryLevelIn: null,
  batteryLevelOut: null,
  chargeTaxes: null,
  charges: [], // Will be removed in future implementations
  connectedMetadata: null,
  creditcardBrand: null,
  creditcardExpMonth: null,
  creditcardExpYear: null,
  creditcardFingerprint: null,
  creditcardLast4: null,
  creditcardPostalCode: null,
  creditcardSource: null,
  customerAddress1: null,
  customerAddress2: null,
  customerBusinessName: null,
  customerCity: null,
  customerCountry: null,
  customerDateOfBirth: null,
  customerDmsId: null,
  customerEmail: null,
  customerExternalId: null,
  customerFirstName: null,
  customerInsuranceCompanyName: null,
  customerInsurancePolicyExpiry: null,
  customerInsurancePolicyNumber: null,
  customerInsuranceProvince: null,
  customerLanguage: null,
  customerLastName: null,
  customerLicenseExpires: null,
  customerLicenseNumber: null,
  customerLicenseState: null,
  customerNote: null,
  customerNotificationPreference: null,
  customerPhoneBusiness: null,
  customerPhoneCell: null,
  customerPhoneResidential: null,
  customerPostalCode: null,
  customerSex: null,
  customerSignatureIp: null,
  customerSignatureStatus: null,
  customerSignatureTimestamp: null,
  customerSignature: null,
  customerSource: null,
  customerState: null,
  customerLicense: null,
  customerInsurance: null,
  damagesIn: [],
  damagesOut: [],
  dateDue: null,
  dateIn: null,
  dateOutChanged: null,
  dateOut: null,
  daysOpen: null,
  daysOverdue: null,
  dealership: null,
  department: null,
  discountTotal: null,
  fuelIn: null,
  fuelOut: null,
  fuelUsed: null,
  id: null,
  itemizedTaxes: [],
  kmAllowed: null,
  latentCharges: [],
  manuallyNotifiedAgent: null,
  manuallyNotifiedDate: null,
  message: null,
  odometerIn: null,
  odometerOut: null,
  overdueNotificationHours: null,
  privateNotes: null,
  propagateData: null,
  publicNotes: null,
  roId: null,
  secondarySignature: null,
  secondarySignatureIp: null,
  secondarySignatureStatus: null,
  secondarySignatureTimestamp: null,
  status: null,
  subtotal: null,
  totalDriven: null,
  total: null,
  transactions: [],
  trips: [],
  vehicleAvailability: null,
  vehicleBatteryLevel: null,
  vehicleBody: null,
  vehicleDepartment: null,
  vehicleExteriorColor: null,
  vehicleFuelLevel: null,
  vehicleFuelTankCapacity: null,
  vehicleFuelType: null,
  vehicleFuelUnit: null,
  vehicleInteriorColor: null,
  vehicleLicensePlate: null,
  vehicleMake: null,
  vehicleModel: null,
  vehicleOdometerUnit: null,
  vehicleOdometer: null,
  vehicleSource: null,
  vehicleStatus: null,
  vehicleStockNumber: null,
  vehicleTagNumber: null,
  vehicleVin: null,
  vehicleYear: null,
};

const emptyDateObject: DateObject = {
  date: '',
  month: '',
  year: '',
};

const reduxAgreementDefaultValues: ReduxAgreement = {
  ...agreementDefaultValues,
  additionalDriverDateOfBirth: emptyDateObject,
  additionalDriverLicenseExpires: emptyDateObject,
  customerDateOfBirth: emptyDateObject,
  customerLicenseExpires: emptyDateObject,
  customerInsurancePolicyExpiry: emptyDateObject,
};

export const AgreementRecordFactory = Record(agreementDefaultValues);
export const ReduxAgreementRecordFactory = Record(reduxAgreementDefaultValues);
